import { render } from "./basicInfo.vue?vue&type=template&id=4b391be6&scoped=true&ts=true"
import script from "./basicInfo.vue?vue&type=script&lang=ts"
export * from "./basicInfo.vue?vue&type=script&lang=ts"

import "./basicInfo.vue?vue&type=style&index=0&id=4b391be6&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/OfferCloud2_FrontWebs_All/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b391be6"]])

export default __exports__